import { defineMessages } from 'react-intl';

const _default_1: {
	placeholderButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	placeholderButtonLabel: {
		id: 'company-hub.company-hub-common.spotlight.button-label.placeholder',
		defaultMessage: 'View',
		description:
			'Placeholder label that appears in the extension button if there is no text input by the user',
	},
});
export default _default_1;
